// extracted by mini-css-extract-plugin
export default {"button":"myButton_button__i7Qwx"};